/* Stylesheet */

.page_layout_wrapper {
  padding: 52px 32px 192px 32px;
  margin: 0 auto;
  width: 90%;
}
